import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { QuickViewDialogComponent } from '../marketplace-card/quick-view-dialog/quick-view-dialog.component';
import { FavoriteService, UserService } from 'services/common';
import { ReloadService, UiService } from 'services/core';
import { Advert, Favorite } from 'interfaces/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-feature-card',
  templateUrl: './feature-card.component.html',
  styleUrls: ['./feature-card.component.scss'],
})
export class FeatureCardComponent implements OnInit, OnDestroy {
  @Input() advert!: Advert;
  public structuredData!: SafeHtml;

  favorites!: Favorite[];
  favorite!: Favorite | undefined;
  isFavorite = false;
  private destroy$ = new Subject<void>(); // Subject to manage unsubscriptions

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private FavoriteService: FavoriteService,
    private reloadService: ReloadService,
    private userService: UserService,
    private uiService: UiService,
    private sanitizer: DomSanitizer
  ) {}

  get categoryName() {
    return this.advert.category?.name;
  }

  get name() {
    return this.advert.name;
  }

  ngOnInit() {
    this.reloadService.refreshFavorite$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.getFavoriteByUser();
      });

    this.getFavoriteByUser();
    const locationParts = [
      this.advert.division?.name,
      this.advert.area?.name,
      this.advert.zone?.name,
    ].filter(Boolean);
    /*const advertJsonLd = {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: this.advert.name,
      description: this.advert.shortDescription,
      image: this.advert.images || [],
      brand: {
        '@type': 'Organization',
        name: 'MyEscort.dk',
      },
      areaServed: locationParts.map(e => ({
        '@type': 'City',
        name: e,
      })),
      offers: {
        '@type': 'Offer',
        url: `https://www.myescort.dk/ad-details/${this.advert.shortId}`,
        priceCurrency: 'DKK',
        price: this.advert.pricing?.[0]?.priceValue ?? '500',
        availability: 'https://schema.org/InStock',
        validFrom: new Date(this.advert.publishDate).toISOString(),
      },
    };*/

    const advertJsonLd = {
      '@context': 'https://schema.org',
      "@type": "Service",
      "serviceType": "Escort Service",
        "name": this.advert.name,
        "description": this.advert.shortDescription,
        "areaServed": {
          "@type": "City",
          "name": this.advert.area?.name,
          "address": {
            "@type": "PostalAddress",
            "streetAddress": this.advert.address,
            "addressLocality": this.advert.area?.name,
            "postalCode": "9000",
            "addressCountry": "DK"
          }
        },

        "provider": {
          "@type": "LocalBusiness",
          "name": this.advert.name,
          "image": this.advert.images || [],
          "url": `https://www.myescort.dk/ad-details/${this.advert.shortId}`,
          "telephone": this.advert.phone,
          "address": {
            "@type": "PostalAddress",
            "streetAddress": this.advert.address,
            "addressLocality": this.advert.area?.name,
            "postalCode": "9000", 
            "addressCountry": "DK"
          },
          "priceRange": "Not specified"
        },
  };



    this.structuredData = this.sanitizer.bypassSecurityTrustHtml(
      `<script type="application/ld+json">${JSON.stringify(advertJsonLd)}</script>`
    );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public openComponentDialog(id: number) {
    this.dialog.open(QuickViewDialogComponent, {
      data: id,
      panelClass: ['theme-dialog', 'full-screen-modal'],
      autoFocus: false,
      disableClose: false,
    });
  }

  private getFavoriteByUser() {
    this.FavoriteService.getFavoriteByUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        res => {
          this.favorites = res.data;
          this.checkFavorite();
        },
        error => {
          console.log(error);
        }
      );
  }

  addToFavoriteDB(advertId: string) {
    this.FavoriteService.addToFavorite(advertId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        res => {
          this.uiService.success(res.message);
          this.reloadService.needRefreshFavorite$();
        },
        error => {
          console.log(error);
        }
      );
  }

  checkFavorite() {
    this.favorite = this.favorites.find(
      f => (f.advert as Advert)?.id === this.advert.id
    );
    this.isFavorite = !!this.favorite;
  }

  public removeFavoriteById(favoriteId: string) {
    this.FavoriteService.deleteFavoriteById(favoriteId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        res => {
          this.reloadService.needRefreshFavorite$();
          this.uiService.success(res.message);
        },
        error => {
          console.log(error);
        }
      );
  }

  onAddToFavorite(event: MouseEvent) {
    event.stopPropagation();
    if (this.favorite) {
      this.removeFavoriteById(this.favorite?.id);
    } else {
      if (this.userService.getUserStatus()) {
        this.addToFavoriteDB(this.advert.id);
      } else {
        this.router.navigate(['/login']);
        this.reloadService.needRefreshFavorite$();
      }
    }
  }
}
